import { createTypedUseAuth } from '@codezo/auth';
import { AuthRoleEnum } from '@codezo/graphql';

export type AdminUserType = {
	id: string;
	email: string;
	role: AuthRoleEnum;
	organizationId?: string;
	organization?: {
		id: string;
		name: string;
	};
};

export const useAuth = createTypedUseAuth<AdminUserType>();
